import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Badge } from 'bookraw/shared/models/badge.model';

@Injectable()
export class BadgesService extends ListService<Badge> {

  url: string = '/api/admin/badges';
}
